import { MaterialSymbol, withStyles } from 'vopay';
import styles from './RecentTransactions.module.scss';
import { useTranslation } from 'react-i18next';
import { format } from 'date-fns';

const cn = withStyles(styles);

export default function NoRecentTransactions() {
  const { t } = useTranslation('translations', { keyPrefix: 'HomepageRevamp.Widgets.RecentTransactions' });

  return (
    <div style={{ flex: 1 }}>
      <div className={cn('noRecentTransactionContainer')}>
        <MaterialSymbol icon="calendar_today" size="72px" fillAmount={1} color="#D9D9D9" />
        <h5>{t('noRecentTransactionMessage', { date: format(new Date(), 'MMMM yyyy') })}</h5>
      </div>
    </div>
  );
}
